const withBasePath = (path) => `/api/${path}`;
const withInsightBasePath = (path) => `/api/insight/${path}`;

// Authentication endpoint
export const LOGIN_API = withBasePath('authenticate');

// Public endpoints without authentication
export const VALIDATE_CREDENTIALS = withBasePath('public/validate-credentials');
export const REQUEST_PASSWORD_RESET_API = withBasePath('public/forgot-password');
export const PASSWORD_RESET_API = withBasePath('public/reset-password');
export const VERIFY_TOKEN_API = withBasePath('public/verify-token');
export const REGISTER_USER = withBasePath('public/register-user');
export const ACTIVATE_USER = withBasePath('public/activate-user');
export const INVITE_USERS = withBasePath('public/invite-users');
export const VALIDATE_EMAIL = withBasePath('public/validate-email');
export const APPLICATION_SETTINGS = withBasePath('public/application-settings');
export const TB_LOCATION_DATA = withBasePath('public/tb/location-data');
export const TB_LOCATION_SITES_DATA = withBasePath('public/tb/location-data/sites');

// User endpoints
export const USER_LOGOUT_API = withBasePath('user/logout');
export const USER_DETAILS_API = withBasePath('user/details');
export const USER_2FA_TOTP_URL_API = withBasePath('user/2fa-totp-url');
export const USER_EMAIL_INVITE = withBasePath('user/validate-email-invite');

// Admin endpoints
export const ADMIN_USERS = withInsightBasePath('admin/users');
export const ADMIN_USERS_ACTIVATION = withInsightBasePath('admin/users/activation');
export const ADMIN_REFRESH_LONG_TERM_CACHE = withInsightBasePath('admin/refresh-long-term-cache');
export const ADMIN_REFRESH_SHORT_TERM_CACHE = withInsightBasePath('admin/refresh-short-term-cache');

//Application endpoints
export const AGROLOG_ANALYTICS_BASIC_AUTHORIZATION_CODE = withInsightBasePath('agrolog-analytics/authorization-code');
export const REFRESH_CACHE = withInsightBasePath('agrolog/refresh-cache');

// Thingsboard related endpoints
// Manager API's
export const TB_MANAGER_RPC = withInsightBasePath('tb/manager/rpc');
export const TB_MANAGER_SITES_DATA = withInsightBasePath('tb/manager/sites');
export const TB_MANAGER_TENANTS_ASSET_INFO = withInsightBasePath('tb/manager/tenants/asset-info');
export const TB_MANAGER_DEVICES_DATA = withInsightBasePath('tb/manager/tenants/devices');
export const TB_MANAGER_ASSETS_DATA = withInsightBasePath('tb/manager/tenants/assets');
export const TB_MANAGER_ASSETS_WITH_RELATIONS_DATA = withInsightBasePath('tb/manager/tenants/assets/relations');
export const TB_MANAGER_ASSETS_DEVICES_WITH_TELEMETRY = withInsightBasePath(
  'tb/manager/telemetries/assets-and-devices'
);
export const TB_MANAGER_DEVICES_WITH_TELEMETRY = withInsightBasePath('tb/manager/telemetries/devices');
export const TB_MANAGER_TENANTS_WITH_TELEMETRY = withInsightBasePath('tb/manager/telemetries/tenants');
export const TB_MANAGER_TENANTS_COUNTER = withInsightBasePath('tb/manager/tenants/counter');
export const TB_MANAGER_TENANTS_MASTER = withInsightBasePath('tb/manager/tenants/master');
export const TB_MANAGER_TENANT_CUSTOMERS_TELEMETRIES = withInsightBasePath('tb/manager/tenant/customers');

// Farmer API's
export const TB_FARMER_CUSTOMERS = withInsightBasePath('tb/farmer/customers');
export const TB_FARMER_CUSTOMERS_RELATIONS_DATA = withInsightBasePath('tb/farmer/customers/relations');
export const TB_FARMER_CUSTOMERS_DATA = withInsightBasePath('tb/farmer/customers/data');
export const TB_FARMER_CUSTOMER_DEVICE_UNASSIGN = withInsightBasePath('tb/farmer/customer/device/unassign');
export const TB_FARMER_CUSTOMER_DEVICE_ASSIGN = withInsightBasePath('tb/farmer/customer/device/assign');
export const TB_FARMER_DEVICES_DATA = withInsightBasePath('tb/farmer/devices');
export const TB_FARMER_DEVICES_DATA_BY_TYPE = withInsightBasePath('tb/farmer/devices/type');
export const TB_FARMER_ASSETS_DATA = withInsightBasePath('tb/farmer/assets');
export const TB_FARMER_ASSETS_FILTERED = withInsightBasePath('tb/farmer/assets-filtered');
export const TB_FARMER_SPEARS_TELEMETRY_DATA = withInsightBasePath('tb/farmer/spears/telemetry');
export const TB_FARMER_DEVICES_TELEMETRY_DATA = withInsightBasePath('tb/farmer/devices/telemetry');
export const TB_FARMER_ALARMS = withInsightBasePath('tb/farmer/alarms-filtered');
export const TB_FARMER_RELATIONS_DELETE_CUSTOMER_TO_DEVICE = withInsightBasePath('tb/farmer/relation/customer-device');
export const TB_FARMER_USER_ACCESS_TOKEN = withInsightBasePath('tb/farmer/access-token');

// Farmer Telemetry API's
export const TB_FARMER_TELEMETRY_ATTRIBUTE_UPDATE = withInsightBasePath('tb/farmer/telemetry/attribute');

// Manager Telemetry API's
export const TB_MANAGER_TELEMETRY_ENTITY = withInsightBasePath('tb/manager/telemetry');
export const TB_MANAGER_TELEMETRY_ATTRIBUTE_UPDATE = withInsightBasePath('tb/manager/telemetry/attribute');

//Health API's
export const MANAGER_TELEMETRY_STATUS_CHECK = withInsightBasePath('manager/health/telemetries');
export const FARMER_TELEMETRY_STATUS_CHECK = withInsightBasePath('farmer/health/telemetries');

//Odoo API's
export const ODOO_TENANTS = withInsightBasePath('odoo/tenants');
export const ODOO_SALES_ORDERS = withInsightBasePath('odoo/sales-orders');
export const ODOO_NOTE = withInsightBasePath('odoo/note');

//ChargeBee API's
export const CHARGEBEE_CUSTOMERS = withInsightBasePath('chargebee/customers');
export const CHARGEBEE_SUBSCRIPTIONS = withInsightBasePath('chargebee/subscriptions');
export const CHARGEBEE_INVOICES = withInsightBasePath('chargebee/invoices');
export const CHARGEBEE_UNBILLED_CHARGES = withInsightBasePath('chargebee/unbilled-charges');
export const CHARGEBEE_SUBSCRIPTION = withInsightBasePath('chargebee/subscription');
